
export const relationTypeEnum = [
    { id: 1, name: "Attendant" },
    { id: 2, name: "Supervisor" },
    { id: 3, name: "Regional Manager" }
];

export const relationTypeEnumById = {
    ATTENDANT: 1,
    SUPERVISOR: 2,
    REGIONAL_MANAGER: 3
};

export const userTypeEnums = {
    Internal: 1,
    Client: 2,
    Vendor: 3,
};

export const userTypeOptionsEnums = [
    { id: "1", name: "Internal" },
    { id: "2", name: "Client" },
    { id: "3", name: "Vendor" }
];